export default __webpack_public_path__ + "static/static-banner-3-c5b667e4f1270cbd9795eded67902975.jpg";